import { render, staticRenderFns } from "./contentQuote.vue?vue&type=template&id=35a409c0&scoped=true&"
import script from "./contentQuote.vue?vue&type=script&lang=js&"
export * from "./contentQuote.vue?vue&type=script&lang=js&"
import style0 from "./contentQuote.vue?vue&type=style&index=0&id=35a409c0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35a409c0",
  null
  
)

export default component.exports